import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import MovementsTable from '../MovementsTable.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardContentLayout, {
    class: "space-y-8",
    heading: _ctx.$t('views.health.inventory.header.logHeading'),
    "has-period-picker": true,
    "has-pig-type-picker": false
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "border-black border-opacity-10" }, null, -1)),
      _createVNode(MovementsTable)
    ]),
    _: 1
  }, 8, ["heading"]))
}
}

})